import React, { Component } from "react";

import { Row, Col, Popover } from "antd";
import { Margin } from "styled-components-spacing";
import Center from "react-center";
import {
  InstagramOutlined,
  MailOutlined,
  LinkedinOutlined,
} from "@ant-design/icons";

// CSS Files
import "../../../Fonts/Fonts.css";
import "../../../Statics/Common/FontStyle.css";
import "../../../Statics/AboutUs/HumanResource/HumanResource.css";

const ManagerCard = {
  borderRadius: "20px",
  boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
};

const managerMail = (
  <div>
    <p></p>
  </div>
);
const ManagerTab1 = (props) => {
  return props.size === "laptopdesktop" ? (
    <div>
      <Row>
        <Col span={4}></Col>
        <Col span={16}>
          <div style={ManagerCard}>
            <Row>
              <Col
                span={17}
                style={{
                  backgroundColor: "#f6f6f6",
                  borderRadius: "20px 0 0 20px",
                }}
              >
                <Margin top={3}></Margin>
                <div style={{ paddingRight: "30px", paddingLeft: "30px" }}>
                  <p className="textParagraph">
                   
                    • دکترای مدیریت خدمات درمانی
                    <br />
                    • کارشناس رسمی دادگستری
                    <br />
                    <p style={{ fontWeight: "bold", marginTop: "5%" }}>
                      رزومه:
                    </p>
                    • معاونت فنی ایرانیان پوشش
                    <br />
                    • مدیرعامل شرکت آتیه سازان حافظ
                    <br />
                    • مدیرعامل شرکت بیمه حافظ
                    <br />• مدیر کل اشخاص بیمه ایران
                    <br />
                    • عضو هیات مدیره بیمه ایران
                    <br />
                    • مدیرکل نظارت و بازرسی بیمه مرکزی
                    <br />• معاون صندوق تامین خسارت بدنی
                  </p>
                </div>
              </Col>
              <Col
                span={7}
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "0 20px 20px 0",
                }}
              >
                <Margin top={3}></Margin>
                <Center>
                  <img
                    className="humanResourcePersonPic"
                    src={require("../../../Imgs/AboutUs/HumanResource/riyahi.jpg")}
                  />
                </Center>
                <Margin top={2}></Margin>
                <Center>
                  <Row style={{ direction: "rtl", textAlign: "right" }}>
                    <div
                      className="personRightBorder"
                      style={{
                        direction: "rtl",
                        textAlign: "right",
                        marginRight: "6.5px",
                      }}
                    ></div>
                    <div style={{ marginTop: "-2.5px" }}>
                      <strong
                        style={{
                          fontFamily: "IranSans",
                          fontSize: ".95em",
                          color: "#174561",
                          paddingRight: "5px",
                        }}
                      >
                        دکتر مهدی ریاحی فر
                      </strong>
                      <p
                        style={{
                          fontFamily: "IranSans",
                          fontSize: ".85em",
                          color: "#8d8d8d",
                          paddingRight: "5px",
                        }}
                      >
                        مدیرعامل ایرانیان پوشش{" "}
                      </p>
                    </div>
                  </Row>
                </Center>
                <Margin top={2}></Margin>
                <Center>
                  <a>
                    <LinkedinOutlined
                      style={{
                        fontSize: "1.3em",
                        margin: "5px",
                        color: "#2867B2",
                      }}
                    />
                  </a>
                  <Popover content={managerMail} placement="bottom">
                    <a>
                      <MailOutlined
                        style={{
                          fontSize: "1.3em",
                          margin: "5px",
                          color: "#4a00a0",
                        }}
                      />
                    </a>
                  </Popover>
                  <a href="">
                    <InstagramOutlined
                      style={{
                        fontSize: "1.3em",
                        margin: "5px",
                        color: "#E1306C",
                      }}
                    />
                  </a>
                </Center>
                <Margin top={2}></Margin>
                <Center>
                  <p
                    style={{
                      fontFamily: "IranSans",
                      fontSize: ".85em",
                      color: "#8d8d8d",
                      paddingRight: "5px",
                    }}
                  >
                    شماره تماس: 84229999-۰۲۱
                  </p>
                </Center>
              </Col>
            </Row>
          </div>
        </Col>
        <Col span={4}></Col>
      </Row>
    </div>
  ) : props.size === "tablet" ? (
    <div>
      <Row>
        <Col span={2}></Col>
        <Col span={20}>
          <div style={ManagerCard}>
            <Row>
              <Col
                span={16}
                style={{
                  backgroundColor: "#f6f6f6",
                  borderRadius: "20px 0 0 20px",
                }}
              >
                <Margin top={3}></Margin>
                <div style={{ paddingRight: "30px", paddingLeft: "30px" }}>
                <p className="textParagraphTablet">
                  
                    • دکترای مدیریت خدمات درمانی
                    <br />
                    • کارشناس رسمی دادگستری
                    <br />
                    <p style={{ fontWeight: "bold", marginTop: "5%" }}>
                      رزومه:
                    </p>
                    • معاونت فنی ایرانیان پوشش
                    <br />
                    • مدیرعامل شرکت آتیه سازان حافظ
                    <br />
                    • مدیرعامل شرکت بیمه حافظ
                    <br />• مدیر کل اشخاص بیمه ایران
                    <br />
                    • عضو هیات مدیره بیمه ایران
                    <br />
                    • مدیرکل نظارت و بازرسی بیمه مرکزی
                    <br />• معاون صندوق تامین خسارت بدنی
                  </p>
                </div>
              </Col>
              <Col
                span={8}
                style={{
                  backgroundColor: "#fff",
                  borderRadius: "0 20px 20px 0",
                }}
              >
                <Margin top={3}></Margin>
                <Center>
                  <img
                    className="humanResourcePersonPic"
                    src={require("../../../Imgs/AboutUs/HumanResource/riyahi.jpg")}
                  />
                </Center>
                <Margin top={2}></Margin>
                <Center>
                  <Row style={{ direction: "rtl", textAlign: "right" }}>
                    <div
                      className="personRightBorder"
                      style={{
                        direction: "rtl",
                        textAlign: "right",
                        marginRight: "6.5px",
                      }}
                    ></div>
                    <div style={{ marginTop: "-2.5px" }}>
                      <strong
                        style={{
                          fontFamily: "IranSans",
                          fontSize: ".85em",
                          color: "#174561",
                          paddingRight: "5px",
                        }}
                      >
                        دکتر مهدی ریاحی فر
                      </strong>
                      <p
                        style={{
                          fontFamily: "IranSans",
                          fontSize: ".75em",
                          color: "#8d8d8d",
                          paddingRight: "5px",
                        }}
                      >
                        مدیرعامل ایرانیان پوشش{" "}
                        </p>
                    </div>
                  </Row>
                </Center>
                <Margin top={2}></Margin>
                <Center>
                  <a>
                    <LinkedinOutlined
                      style={{
                        fontSize: "1.3em",
                        margin: "5px",
                        color: "#2867B2",
                      }}
                    />
                  </a>
                  <Popover content={managerMail} placement="bottom">
                    <a>
                      <MailOutlined
                        style={{
                          fontSize: "1.3em",
                          margin: "5px",
                          color: "#4a00a0",
                        }}
                      />
                    </a>
                  </Popover>
                  <a href="">
                    <InstagramOutlined
                      style={{
                        fontSize: "1.3em",
                        margin: "5px",
                        color: "#E1306C",
                      }}
                    />
                  </a>
                </Center>
                <Margin top={2}></Margin>
                <Center>
                  <p
                    style={{
                      fontFamily: "IranSans",
                      fontSize: ".75em",
                      color: "#8d8d8d",
                      paddingRight: "5px",
                    }}
                  >
                    شماره تماس: 84229999-۰۲۱
                  </p>
                </Center>
              </Col>
            </Row>
          </div>
        </Col>
        <Col span={2}></Col>
      </Row>
    </div>
  ) : (
    <div>
      <Row>
        <Col span={1}></Col>
        <Col span={22}>
          <div
            style={{
              boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
              backgroundColor: "#fff",
              height: "100%",
              borderRadius: "20px",
            }}
          >
            <div style={{ backgroundColor: "#f6f6f6", borderRadius: "20px" }}>
              <Center>
                <Margin top={3}>
                  <Center>
                    <Margin top={2}>
                      <Center>
                        <img
                          style={{
                            width: "150px",
                            height: "150px",
                            borderRadius: "50%",
                          }}
                          src={require("../../../Imgs/AboutUs/HumanResource/riyahi.jpg")}
                        />
                      </Center>
                    </Margin>
                  </Center>
                  <Center>
                    <Margin top={2}>
                      <Center>
                        <strong
                          style={{
                            fontFamily: "IranSans",
                            fontSize: ".8em",
                            color: "#174561",
                            paddingRight: "10px",
                          }}
                        >
                          دکتر مهدی ریاحی فر
                        </strong>
                      </Center>
                      <Center>
                        <p
                          style={{
                            fontFamily: "IranSans",
                            fontSize: ".75em",
                            color: "#8d8d8d",
                            paddingRight: "10px",
                            marginTop: "5px",
                            textAlign: "center",
                          }}
                        >
                        مدیرعامل ایرانیان پوشش{" "}
                        </p>
                      </Center>
                    </Margin>
                  </Center>
                </Margin>
              </Center>
              <Center>
                <div className="cardTitleHR"></div>
              </Center>
              <Margin top={2}></Margin>
              <div
                style={{
                  padding: "15px",
                  backgroundColor: "#fff",
                  borderRadius: "0 0 20px 20px",
                }}
              >
                  <p className="textParagraphMobile">
                  
                    • دکترای مدیریت خدمات درمانی
                    <br />
                    • کارشناس رسمی دادگستری
                    <br />
                    <p style={{ fontWeight: "bold", marginTop: "5%" }}>
                      رزومه:
                    </p>
                    • معاونت فنی ایرانیان پوشش
                    <br />
                    • مدیرعامل شرکت آتیه سازان حافظ
                    <br />
                    • مدیرعامل شرکت بیمه حافظ
                    <br />• مدیر کل اشخاص بیمه ایران
                    <br />
                    • عضو هیات مدیره بیمه ایران
                    <br />
                    • مدیرکل نظارت و بازرسی بیمه مرکزی
                    <br />• معاون صندوق تامین خسارت بدنی
                  </p>
                <a>
                  <LinkedinOutlined
                    style={{
                      fontSize: "1.3em",
                      margin: "5px",
                      color: "#2867B2",
                    }}
                  />
                </a>
                <Popover content={managerMail} placement="bottom">
                  <a>
                    <MailOutlined
                      style={{
                        fontSize: "1.3em",
                        margin: "5px",
                        color: "#4a00a0",
                      }}
                    />
                  </a>
                </Popover>
                <a href="">
                  <InstagramOutlined
                    style={{
                      fontSize: "1.3em",
                      margin: "5px",
                      color: "#E1306C",
                    }}
                  />
                </a>
                <p
                  style={{
                    fontFamily: "IranSans",
                    fontSize: ".85em",
                    color: "#8d8d8d",
                    paddingRight: "5px",
                  }}
                >
                  شماره تماس: 84229999-۰۲۱
                </p>
              </div>
            </div>
          </div>
        </Col>
        <Col span={1}></Col>
      </Row>
      <Margin bottom={4}></Margin>
    </div>
  );
};

export default ManagerTab1;
